import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=6b715f60&scoped=true"
import script from "./DynamicField.vue?vue&type=script&lang=js"
export * from "./DynamicField.vue?vue&type=script&lang=js"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=6b715f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b715f60",
  null
  
)

export default component.exports